<script setup lang="ts">
  import type { LegalDocument } from '@/models/document';
  import type { PropType } from 'vue';

  defineProps({
    document: {
      type: Object as PropType<LegalDocument>,
      required: true
    }
  });
</script>

<template>
  <section class="document-section">
    <div class="container">
      <div
        class="document-section__content"
        v-html="document.content" />
    </div>
  </section>
</template>
